var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"alt":"","src":require("../assets/ic_no_data.png")}}),_c('div',{staticClass:"text"},[_vm._v("暂无内容")])])
}]

export { render, staticRenderFns }